import Event from '../../core/Event';

export default class OrderProductsGetRequested extends Event {
    public static type = 'OrderProductsGetRequested';

    constructor() {
        super(OrderProductsGetRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderProductsGetRequested.ts